import React from "react"
import styled from "styled-components"
import Icon from "./icon"

const MenuContainer = styled.aside`
    position: absolute;
    width: 100%;
    background: rgba(0, 0, 0, 0.97);
    color: white;
    max-height: 100vh;
    overflow-y: auto;
    right: 0;
    top: 0;
    z-index: 1001;
    transition: all 500ms cubic-bezier(0.85, 0, 0.15, 1);
    transform: ${props =>
        props.isOpen ? "translateX(0)" : "translateX(100%) "};
    @media screen and (min-width: 768px) {
        width: 375px;
        position: fixed;
    }
`

const Overlay = styled.div`
    position: fixed;
    height: 100vh;
    width: 100vw;
    z-index: 1000;
    top: 0;
    left: 0;
    transition: all 500ms cubic-bezier(0.85, 0, 0.15, 1);
    background: ${props =>
        props.isOpen ? "rgba(0, 0, 0, 0.7)" : "rgba(0, 0, 0, 0.0)"};
    pointer-events: ${props => (props.isOpen ? "all" : "none")};
`

const SMContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    padding: 14px 0;
    a img {
        height: 30px;
        padding: 0 0.5rem;
    }
`

const CloseButton = styled.div`
    position: absolute;
    left: 0.5rem;
`

const LinksContainer = styled.div`
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
`

const SectionContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 1rem;
    margin: 1rem;
    &:first-child {
        border-bottom: 1px solid ${props => props.theme.background};
        padding-bottom: 1.4rem;
    }
`

const Link = styled.a`
    font-size: 1rem;
    padding: 0.5rem 0;
    text-decoration: none;
    color: ${props => props.theme.background};
`

const ImageLink = styled(Link)`
    text-transform: uppercase;
    display: flex;
    flex-direction: column;
    img {
        width: 100%;
        height: 7rem;
        padding-bottom: 0.5rem;
        object-fit: cover;
    }
`

export default function Menu({ data, isOpen, closeMenu, images }) {
    return (
        <React.Fragment>
            <Overlay isOpen={isOpen} />
            <MenuContainer isOpen={isOpen}>
                <CloseButton onClick={closeMenu}>
                    <Icon
                        color={"#f5f5f5"}
                        size={42}
                        style={{ cursor: "pointer" }}
                    >
                        close
                    </Icon>
                </CloseButton>
                <SMContainer>
                    <div>
                        {data.social_media_links.map(el => {
                            return (
                                <a
                                    key={el.name}
                                    href={el.url}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <img
                                        alt={el.name + " logo"}
                                        src={`https://www.tuffshed.com/wp-content/themes/tsretail/assets/images/${el.name.toLowerCase()}.png`}
                                    />
                                </a>
                            )
                        })}
                    </div>
                </SMContainer>
                <LinksContainer>
                    <SectionContainer>
                        {data.links.map(el => {
                            if (el.section === "Shop") {
                                return (
                                    <ImageLink
                                        key={el.name}
                                        href={el.url}
                                        target="_blank"
                                        rel="nofollow"
                                    >
                                        <img
                                            src={images[el.image].fluid.src}
                                            alt={el.name}
                                        />
                                        {el.name}
                                    </ImageLink>
                                )
                            } else return null
                        })}
                    </SectionContainer>
                    <SectionContainer>
                        {data.links.map(el => {
                            if (el.section === "Company") {
                                return (
                                    <Link
                                        key={el.name}
                                        href={el.url}
                                        target="_blank"
                                        rel="nofollow"
                                    >
                                        {el.name}
                                    </Link>
                                )
                            } else return null
                        })}
                    </SectionContainer>
                </LinksContainer>
            </MenuContainer>
        </React.Fragment>
    )
}
